class Modal {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = document.querySelectorAll('[data-js="modal-trigger"]');
    this.dom.closer = this.dom.el.querySelectorAll('[data-js="modal-closer"]');

    this.slug = null;
    this.target = null;

    this.isShow = false;

    this.toggleModal = this.toggleModal.bind(this); 

    this.init();
  }

  init() {

    [...this.dom.trigger].forEach(el => {
      el.addEventListener('click', this.toggleModal);
    });
    [...this.dom.closer].forEach(el => {
      el.addEventListener('click', this.toggleModal);
    });
  }

  toggleModal(e) {
    if (!this.isShow) {
      this.dom.el.dataset.is = 'show'
      this.slug = e.currentTarget.dataset.products;
      this.target = this.dom.el.querySelector(`[data-products="${this.slug}"]`)
      this.target.dataset.is = 'show'
      this.isShow = true;
    } else {
      this.target.removeAttribute('data-is')
      this.isShow = false;
      this.dom.el.removeAttribute('data-is')
    }
  }
}

export default Modal